<template>
  <div id="purchase-order" style="width:760px;padding:0 30px;margin:0 20px;">
    <div class="page-header">
    <div class="row ">
      <div class="col-xs-6">
        <img src="../../public/static/img/logo.png"/>
      </div>
      <div class="col-xs-6">
        <h1 style="text-align:right;color: #7d1011;font-size: 34px;margin-bottom:41px;margin-top: 0;">PURCHASE ORDER</h1>
        <table style="float: right;font-size: 13px; margin-bottom: 0;">
          <tr>
            <td style="padding:0 10px 0 0;font-weight: bold;">PO NUMBER</td>
            <td style="padding:0;font-weight: bold;">{{lpoNumber}}</td>
          </tr>
          <tr>
            <td style="padding:0 10px 0 0;font-weight: bold;">PO DATE</td>
            <td style="padding:0;font-weight: bold;">{{orderDate | dateFormat}}</td>
          </tr>
          <tr>
            <td style="padding:0 10px 0 0;font-weight: bold;">REFERENCE #</td>
            <td style="padding:0;font-weight: bold;">{{referenceNumber}}</td>
          </tr>
        </table>
      </div>
    </div>
    </div>
    
    <!-- <div class="row">
      <div class="col-xs-6">
        <table style="margin-bottom: 10px;">
          <tr>
            <td style="padding:0 10px 0 0;font-weight: bold;">EXPECTED DATE</td>
            <td style="padding:0">{{expectedDate | dateFormat}}</td>
          </tr>
        </table>
      </div>
      <div class="col-xs-6">
        <table>
           <tr>
            <td style="padding:0 10px 0 0;font-weight: bold;">TRN #</td>
            <td style="padding:0">{{companyTRN}}</td>
          </tr>
        </table>
      </div>
    </div> -->
    <div class="row">
      <div class="col-xs-12">
        <b-table-simple bordered>
          <b-thead head-variant="dark">
            <b-tr class="bg-prime"  style="text-transform:uppercase;">
              <b-th>
                Vendor Details
              </b-th>
              <b-th>Bill To
              </b-th>
              <b-th>Ship To</b-th>
            </b-tr>
          </b-thead>
          <b-tbody>
            <b-tr variant="info">
              <b-td>{{vendorDetails.supplier_name}}<br/>
                {{vendorDetails.supplier_address}}<br/>
                {{vendorDetails.supplier_city}} P.O Box: {{vendorDetails.supplier_po}}<br/>
                {{vendorDetails.supplier_country}}<br/>
                Phone: {{vendorDetails.supplier_phone}}<br/>
                TRN: {{vendorDetails.supplier_trn}}<br/>
                Attn: {{supplierContact}}
              </b-td>
              <b-td style="min-width:200px;">
                {{companyName}}<br/>
                P.O Box: {{companyPO}}
                {{companyAddress}}<br/>
                {{companyCity}}<br/>
                {{companyCountry}}<br/>
                Email: {{companyEmail}}<br/>
                TRN #: {{companyTRN}}
              </b-td>
              <b-td style="min-width: 200px;">
                {{deliveryDetails.site_name}}<br/>
                {{deliveryDetails.site_address}}<br/>
                {{deliveryDetails.site_city && deliveryDetails.site_city}}<br/>                
                {{deliveryDetails.site_country}}<br/>
                Phone: {{siteContactNo}}<br/>
                Attn: {{siteContactPerson}}
              </b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12">
        <b-table-simple bordered class="item-table" style="page-break-before:avoid;height:auto;">
          <b-thead head-variant="dark" style="display: table-header-group;">
            <b-tr class="bg-prime" style="text-transform:uppercase;">
              <b-th>
                S.No
              </b-th>
              <b-th>Item Details
              </b-th>
              <b-th>Qty</b-th>
              <b-th>UOM</b-th>
              <b-th>Unit Price</b-th>
              <b-th>VAT</b-th>
              <b-th>Sub Total</b-th>
            </b-tr>
          </b-thead>
          <b-tbody style="page-break-inside:auto">
            <b-tr v-for="(item, k) in cartItems" :key="k" style="page-break-inside:avoid;page-break-after:auto;" class="trow">
              <b-td>{{k + 1}}</b-td>
              <b-td>
                {{item.product_name}}
              </b-td>
              <b-td>                  
                {{item.quantity}}</b-td>
              <b-td>                  
                {{item.uom}}</b-td>
              <b-td>{{item.price | amount}}
              </b-td>
              <b-td>{{(item.sub_total * (showVAT ? 0.05 : 0)) | amount}}</b-td>
              <b-td>{{(item.sub_total) | amount}}
              </b-td>
            </b-tr>
            <b-tr>
              <b-td colspan="5" style="text-transform:uppercase;font-weight: bold;text-align: right;">
              Discount </b-td>
              <b-td></b-td>
              <b-td style="font-weight: bold;">{{discount | amount}}</b-td>
            </b-tr>
            <b-tr>
              <b-td colspan="5" style="text-transform:uppercase;font-weight: bold;text-align: right;">
              Total Amount</b-td>
              <b-td style="font-weight: bold;">{{taxAmount | amount}}</b-td>
              <b-td style="font-weight: bold;">{{totalAmount | amount}}</b-td>
            </b-tr>
            <b-tr>
              <b-td colspan="7">
                <p style="text-transform: capitalize; margin-bottom: 0px;">
                  <span style="font-weight:bold;margin-bottom: 0px;">Amount in words: </span>
                  {{amountWords}}
                </p>
              </b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>
      </div>
    </div>
    <!-- <div class="row">
      <div class="col-xs-12">
        <b-table-simple bordered>
          <b-thead head-variant="dark">
            <b-tr class="bg-prime" style="text-transform:uppercase;">
              <b-th>
                Discount
              </b-th>
              <b-th>Amount Excl. VAT
              </b-th>
              <b-th>
                VAT Rate
              </b-th>
              <b-th>VAT Amount</b-th>
              <b-th>Total Amount</b-th>
            </b-tr>
          </b-thead>
          <b-tbody>
            <b-tr>
              <b-td>{{discount | amount }}</b-td>
              <b-td>
                {{cartTotal | amount}}
              </b-td>
              <b-td>5%</b-td>
              <b-td>                  
                {{taxAmount | amount}}</b-td>
              <b-td>{{totalAmount | amount}}
              </b-td>
            </b-tr>
            <b-tr>
              <b-td colspan="4" style="text-transform:uppercase;font-weight: bold;text-align: right;">
              Total Amount</b-td>
              <b-td style="font-weight: bold;">{{totalAmount | amount}}</b-td>
            </b-tr>
            <b-tr>
              <b-td>
                <p style="font-weight:bold;margin-bottom: 0px;">Amount in words</p>
              </b-td>
              <b-td colspan="4">
                <p style="text-transform: capitalize; margin-bottom: 0px;">{{amountWords}}</p>
              </b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>
      </div>
    </div> -->
    <div class="row">
      <div class="col-xs-12">
        <b-table-simple bordered>
          <b-thead head-variant="dark">
            <b-tr class="bg-prime" style="text-transform:uppercase;">
              <b-th>
                Payment Terms
              </b-th>
              <!-- <b-th>Currency
              </b-th> -->
              <!-- <b-th>Delivery Date</b-th> -->
            </b-tr>
          </b-thead>
          <b-tbody>
            <b-tr>
              <b-td>
                {{paymentTerm.term_name}}
              </b-td>
              <!-- <b-td>                  
                {{currency}}</b-td> -->
              <!-- <b-td>{{expectedDate | dateFormat}}</b-td> -->
            </b-tr>
          </b-tbody>
        </b-table-simple>
      </div>
    </div>
    <div v-if="remarks != ''" class="row">
      <div class="col-xs-12">
        <b-table-simple bordered>
          <b-thead>
            <b-tr class="bg-prime" style="text-transform:uppercase;">
              <b-th>
                Notes for Vendor
              </b-th>
            </b-tr>
          </b-thead>
          <b-tbody>
            <b-tr>
              <b-td>
                {{remarks}}
              </b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12">
        <table>
          <tr>
            <td colspan="2" width="422" style="width:422px;height:100px;vertical-align: bottom;">
              {{requestedBy}}
            </td>
            <!-- <td width="300" style="width:300px;height:100px;"></td> -->
            <td colspan="2" width="422" style="width:422px;height:100px;vertical-align: bottom;">
              <img v-if="lpoStatus == 1" width="122" style="width:122px" src="../../public/static/img/sign.jpeg"/>
              <br/>{{preparedBy}}
            </td>
            <!-- <td width="300" style="width:300px;height:100px;text-align: center;"></td> -->
            <td width="122" style="width:122px;height:100px;text-align: center;">
            </td>
          </tr>
          <tr>
            <td width="122" style="width:122px;text-align: left;">Requested By</td>
            <td width="300" style="width:300px;"></td>
            <td width="122" style="width:122px;text-align: left;">Prepared By</td>
            <td width="300" style="width:300px;"></td>
            <td width="122" style="width:122px;text-align: center;">Approved By</td>
          </tr>
        </table>
       <!--  <p style="font-weight:bold;margin-bottom: 20px;margin-top:10px">Approved on behalf of {{companyName}}</p>
         -->
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12">
        <p style="text-align:right;">
          <img height="60" style="height: 60px;" src="../../public/static/img/tuv_logo.png"/> 
          <img height="60" style="height: 60px;" src="../../public/static/img/eiac_logo.png"/>
          <img height="60" style="height: 60px;" src="../../public/static/img/oshad_logo.png"/>
          <img height="60" style="height: 60px;" src="../../public/static/img/icv_logo.png"/>
        </p>

      </div>
    </div>
        <l-p-o-terms v-if="showTerms"/>

    <div class="page-footer">
      <p style="text-align:center">{{companyName}} | {{companyWebsite}} | Phone: {{companyPhone}} | Fax: {{companyFax}}</p>
    </div>
  </div>
</template>

<script>
import config from "../config";
import { BTableSimple, BThead, BTbody, BTr, BTh, BTd } from "bootstrap-vue";
import LPOTerms from './LPOTerms.vue'
var converter = require('number-to-words');

export default {
  props: ["purchaseId", "item", "cartItems", 'showTerms', "lpoStatus", "showVAT"],
  name: "PurchaseOrder",
  data() {
    return {
      companyEmail: config.companyEmail,
      companyTRN: config.companyTRN,
      companyName: config.companyName,
      companyAddress: config.companyAddress,
      companyCity: config.companyCity,
      companyCountry: config.companyCountry,
      companyPO: config.companyPO,
      companyPhone: config.companyPhone,
      companyFax: config.companyFax,
      companyWebsite: config.companyWebsite,
      saveCat: false,
      itemId: this.item.purchase_id,
      orderDate: this.item.order_date,
      expectedDate: this.item.expected_date,
      currency: this.item.currency,
      referenceNumber: this.item.reference_number,
      supplierContact: this.item.supplier_contact_person,
      siteContactPerson: this.item.site_contact_person,
      siteContactNo: this.item.site_contact_number,
      supplier: {supplier_id: this.item.supplier_id, supplier_name: this.item.supplier_name},
      project: {project_id: this.item.project_id, project_name: this.item.project_name},
      location: {site_id: this.item.site_id, site_name: this.item.site_name},
      paymentTerm: { term_id: this.item.payment_term_id, term_name: this.item.payment_term_name},
      requestedBy: this.item.requested_by,
      preparedBy: this.item.prepared_by,
      remarks: this.item.remarks,
      amount: this.item.amount,
      discount: this.item.discount,
      errors : [],
      loading: false,
      // lpoStatus: this.item.order_status,
    };
  },
  components: {
    LPOTerms,
    BTableSimple, BTd, BThead, BTbody, BTr, BTh
  },
  filters: {
    capitalize: function (value) {
      if (!value) return ''
      value = value.toString()
      return value.charAt(0).toUpperCase() + value.slice(1)
    },
    amount: function (value) {
      if (!value) return ''
      value = value.toString()
      return Number(value).toFixed(2)
    },
    dateFormat: function(date) {
      /* var options = {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
      }; */
      var formatdate = new Date(date);
      var dateformat = formatdate.toLocaleDateString("en-GB");
      return dateformat;
    }
  },
  computed: {
    amountWords: function () {
      let amount = 'AED ';
      const total = Number(this.totalAmount).toFixed(2);
      console.log('Total:', total);
      const aedPart = Math.floor(total);
      const filsPart = parseInt(((total % 1) * 100).toFixed(2));
      amount = amount + converter.toWords(aedPart);
      if (filsPart) {
        console.log(filsPart)
        const fils = converter.toWords(filsPart);
        amount += ' And Fils ' + fils;
      }
      return amount + ' Only';
    },
    vendorDetails: function() {
      const vendor = {
        supplier_name: this.item && this.item.supplier_name,
        supplier_address: this.item && this.item.supplier_address,
        supplier_city: this.item && this.item.supplier_city,
        supplier_po: this.item && this.item.supplier_po,
        supplier_country: this.item && this.item.supplier_country,
        supplier_phone: this.item && this.item.supplier_phone,
        supplier_trn: this.item && this.item.supplier_trn
      }
      return vendor
    },
    deliveryDetails: function() {
      const location = {
        site_name: this.item && this.item.site_name,
        site_address: this.item && this.item.site_address,
        site_city: this.item && this.item.site_city,
        site_country: this.item && this.item.site_country
      }
      return location;
    },
    lpoNumber: function () {
      return 'LPO-' + this.item.purchase_id;
    },
    cartTotal: function () {
      var total = this.cartItems.reduce((acc, item) => acc + item.sub_total, 0)
      return total
    },
    taxAmount: function () {
      const vat = this.showVAT ? 0.05 : 0;
      const total = (this.cartTotal - this.discount) * vat;
      return total
    },
    totalAmount: function () {
      const total = this.cartTotal - this.discount + this.taxAmount;
      return total;
    },
    getStatus: function () {
      if (this.itemId) {
        if (this.lpoStatus < 0) {
          return 'Rejected'
        } else if (this.lpoStatus > 0) {
          return 'Approved'
        } else {
          return 'Waiting for Approval'
        }
      } else {
        return 'Draft'
      }
    }
  },
  methods: {
  },
  mounted() {
  },
};
</script>

<style scoped>
.item-table{
  page-break-inside: auto;
}
.item-table thead{
  display: table-header-group;
}
.item-table tbody {
  page-break-inside: auto;
}
.item-table tr{
  page-break-inside: avoid;
  page-break-after: auto;
}
#purchase-order{
  -webkit-print-color-adjust: exact;
  color-adjust: exact;
  color: #000000;
}
#purchase-order table td, #purchase-order table th{
  padding: 5px 8px;
}
.page-header{
  border-bottom: none; /*1px solid #cccccc; */
  margin-top: 0;
  margin-bottom: 8px;
}
.page-footer{
  border-top: 1px solid #cccccc; 
}
   .bg-prime, .bg-prime td, .bg-prime th{
    background-color: #919191 !important; /*  #7d1011 */
    color: #ffffff !important;
   }
table{
  margin-bottom: 10px;
}
@page {
  margin: 10mm
}
@media print {   
   body {
    margin: 0;
    -webkit-print-color-adjust: exact;
    color-adjust: exact;
    color: #000000;
  }
  h1 {
    color: #7d1011 !important;
  }
   .bg-gray, .bg-gray td, .bg-gray th{
    background-color: #777777 !important;
    -webkit-print-color-adjust: exact;
    color-adjust: exact;
   }
   .bg-prime, .bg-prime td, .bg-prime th{
    background-color: #7d1011 !important;
    color: #ffffff !important;
    -webkit-print-color-adjust: exact;
    color-adjust: exact;
   }
}
</style>